import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { GuestInHouseVerificationPhotoRecord } from '../../types';
import { DividedList } from './DividedList';

interface CompanionVerificationPhotoListProps {
    companionIds: string[];
    verificationPhotos: GuestInHouseVerificationPhotoRecord;
}

export const CompanionVerificationPhotoList = ({
    companionIds,
    verificationPhotos,
}: CompanionVerificationPhotoListProps) => (
    <DividedList
        collectionIds={companionIds}
        renderItem={(id) => (
            <LocalizedText
                textKey={
                    verificationPhotos?.[id]?.isSubmitted
                        ? TextKey.GuestInHouseReportColumnVerificationPhotoSubmitted
                        : TextKey.GuestInHouseReportColumnVerificationPhotoNotSubmitted
                }
            />
        )}
    />
);
